<div class="overlays-container">

	<ansyn-timeline-overlay-status></ansyn-timeline-overlay-status>

	<ansyn-overlays-loader></ansyn-overlays-loader>

	<ansyn-timeline></ansyn-timeline>

</div>
